export default "__VITE_ASSET__eebe82dd__"